<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-shutdown`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32 7.664C39.064 10.75 44 17.8 44 26c0 11.046-8.954 20-20 20S4 37.046 4 26c0-8.201 4.936-15.25 12-18.336v4.476C11.218 14.907 8 20.078 8 26c0 8.837 7.163 16 16 16s16-7.163 16-16c0-5.922-3.218-11.093-8-13.86V7.664zM22 26V4a1 1 0 011-1h2a1 1 0 011 1v22a1 1 0 01-1 1h-2a1 1 0 01-1-1z"/></svg>
</template>
<script>

export default {
  name: 'IconShutdown',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
